import { render, staticRenderFns } from "./LeadResume.vue?vue&type=template&id=61edd16a&"
import script from "./LeadResume.vue?vue&type=script&lang=js&"
export * from "./LeadResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports